import { CalendarView } from 'angular-calendar';
import { endOfWeek, startOfWeek } from 'date-fns';

import { createReducer } from '../../../store.model';

import {
    ActionType,
    InitEventAction,
    RootChangeView,
    RootInitAction,
    RootInitResultAction,
    RootReloadAction,
    RootReloadResultAction,
} from './calendar.action';
import { defaultState, RootState } from './calendar.state';

const { builder, reducer } = createReducer<ActionType, RootState>(
    defaultState(),
);

builder
    .add<RootInitAction>(ActionType.COACHING_CALENDAR__INIT, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                init: true,
            },
        };
    })
    .add<RootInitResultAction>(
        ActionType.COACHING_CALENDAR__INIT_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    init: false,
                },
                manager: action.payload.manager,
            };
        },
    );

builder
    .add<RootReloadAction>(
        ActionType.COACHING_CALENDAR__RELOAD,
        (state, action) => {
            // do this here so that the calender can at least update it's header/dates until events are fetched
            const view = action.payload.view || state.view;
            const viewDate = action.payload.viewDate || state.startDate;

            let startDate: Date;
            let endDate: Date;
            switch (view) {
                case CalendarView.Day:
                    break;
                case CalendarView.Week:
                    startDate = startOfWeek(viewDate);
                    endDate = endOfWeek(viewDate);
                    break;
                case CalendarView.Month:
                    break;
            }

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: true,
                },
                view,
                viewDate,
                startDate,
                endDate,
                events: [],
                calendarEvents: [],
            };
        },
    )
    .add<RootReloadResultAction>(
        ActionType.COACHING_CALENDAR__RELOAD_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: false,
                },
                // view: action.view,
                // startDate: action.startDate,
                // endDate: action.endDate,
                events: action.payload.events,
                calendarEvents: action.payload.calendarEvents,
            };
        },
    );

builder.add<RootChangeView>(
    ActionType.COACHING_CALENDAR__CHANGE_VIEW,
    (state, action) => {
        return {
            ...state,
            view: action.payload.view,
        };
    },
);

builder.add<InitEventAction>(
    ActionType.COACHING_CALENDAR__INIT_EVENT,
    (state, action) => {
        return {
            ...state,
            eventId: action.payload.eventId,
        };
    },
);

export default {
    coachingCalendar: reducer,
};
